import { PublicBoxSortType } from '../enums/public-box-sort-type';
import { Nillable } from '@web/utils';

export class PublicBoxesQuery {
  public constructor(
    private readonly data: {
      sortType?: Nillable<PublicBoxSortType>;
      categorySlug?: Nillable<string>;
      phrase?: Nillable<string>;
    },
  ) {}

  public get sortType(): Nillable<PublicBoxSortType> {
    return this.data.sortType;
  }

  public get categorySlug(): Nillable<string> {
    return this.data.categorySlug;
  }

  public get phrase(): Nillable<string> {
    return this.data.phrase;
  }
}
